export const PROPERTY_SECTIONS=[['/properties','Search properties'],['/properties/types','Property types'],['/properties/reports','Reports'],['/properties/map','Map'],['/properties/taxes','Find my taxes']];
export const PROPERTY_REPORT_VIEWS = [
  {id:'values', label:'Values', title:'Assessed and appraised values by property type'},
  {id:'sale-vs-appraised', label:'Sale vs Appraised', title:'Sale price vs. appraised value'},
  {id:'recorded-sales', label:'Recorded Sales', title:'Recorded sales by year'},
  {id:'sale-counts', label:'Sale Counts', title:'Recorded sale counts and prices'},
];
